import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import { Head } from '@/components/ui/Typography/Heading/Head';
export const RfpMessageTitle = (props) => {
    const { className = '', status, title } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex items-center gap-8', className) }, { children: [status === 'sent' && (_jsx(SmallTag, Object.assign({ className: 'flex-shrink-0', color: 'discreet' }, { children: "\u56DE\u7B54\u6E08" }))), status === 'received' && (_jsx(SmallTag, Object.assign({ className: 'flex-shrink-0', color: 'info' }, { children: "\u672A\u8FD4\u4FE1" }))), _jsx(Head, Object.assign({ color: 'base', size: 'xxs' }, { children: title }))] })));
};
